<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<div class="cssLayoutRowStartCenter">
  <div class="sp-icon" style="margin-right: 10px;">
    <mat-icon class="mdi-24px" fontIcon="mdi-account-group" [ngStyle]="{'color': 'var(--mat-sys-primary)'}"></mat-icon>
  </div>
  <button mat-icon-button (click)="addOrEditTeam(null)" style="outline: none; margin-left: 20px;" title="Add Team"
    [disabled]="!canEdit">
    <mat-icon class="mdi-24px self-center" fontIcon="mdi-plus-circle"></mat-icon>
  </button>
  <mat-form-field class="button-margins search-field">
    <input matInput [formControl]="filterControl" placeholder="Search" />
    @if (filterControl.value) {
    <button mat-icon-button matSuffix (click)="applyFilter('')" title="Clear Search">
      <mat-icon style="transform: scale(0.85)" fontIcon="mdi-close-circle-outline"></mat-icon>
    </button>
    }
  </mat-form-field>
</div>

<mat-accordion displayMode="flat">
  <section matSort (matSortChange)="sortChanged($event)" class="mat-elevation-z2 header-row">
    <div class="header-cell one-cell"></div>
    <div class="header-cell one-cell" mat-sort-header="shortName">
      Short Name
    </div>
    <div class="header-cell five-cell" mat-sort-header="name">
      Name
    </div>
    <div class="header-cell three-cell" mat-sort-header="teamTypeId">Team Type</div>
  </section>

  @for (team of sortedTeams; track team.id) {
  <mat-expansion-panel [expanded]="editTeam.id === team.id">
    @if (!isLoading) {
    <mat-expansion-panel-header class="row" (click)="togglePanel(team); $event.stopPropagation()">
      <div class="cell one-cell">
        <div class="button-div">
          <button mat-icon-button (click)="addOrEditTeam(team); $event.stopPropagation()" title="Edit {{ team.name }}"
            [disabled]="!canEdit" class="team-button">
            <mat-icon class="mdi-18px self-center" fontIcon="mdi-square-edit-outline"></mat-icon>
          </button>
          <button mat-icon-button (click)="deleteTeam(team); $event.stopPropagation()" title="Delete {{ team.name }}"
            [disabled]="!canEdit" class="team-button">
            <mat-icon class="mdi-18px self-center" fontIcon="mdi-trash-can-outline"></mat-icon>
          </button>
        </div>
      </div>
      <div class="cell one-cell center-self">
        <div class="panel-div">
          {{ team.shortName }}
        </div>
      </div>
      <div class="cell five-cell center-self">
        <div class="panel-div">
          {{ team.name }}
        </div>
      </div>
      <div class="cell three-cell center-self">
        <div class="panel-div">
          {{ getTeamTypeName(team.teamTypeId) }}
        </div>
      </div>
    </mat-expansion-panel-header>
    }
    @if (editTeam.id === team.id) {
    <div class="panel-container">
      <div class="user-div">
        @if (team.id === editTeam.id) {
        <app-admin-team-memberships [teamId]="team.id"></app-admin-team-memberships>
        }
      </div>
    </div>
    }
  </mat-expansion-panel>
  }
</mat-accordion>

@if (isLoading) {
<mat-card appearance="outlined" style="display: flex; justify-content: center; align-items: center;">
  <mat-progress-spinner color="primary" mode="indeterminate">
  </mat-progress-spinner>
</mat-card>
}
